import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Grid, Divider, Form } from "semantic-ui-react";
import polyglot from "../../i18n";
import * as cafReducer from "../../containers/CafForm/caf.reducer";

class CafDepartmentForm extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const manager = (
      <Form.Field>
        <label>{polyglot.t("cafForm.manager")}</label>
      </Form.Field>
    );

    const accounts = (
      <Form.Field>
        <label>{polyglot.t("cafForm.accounts")}</label>
      </Form.Field>
    );
    const purchasing = (
      <Form.Field>
        <label>{polyglot.t("cafForm.purchasing")}</label>
      </Form.Field>
    );

    const managersEmail = (
      <Form.Field>
        <label>{polyglot.t("cafForm.managersEmail")}</label>
      </Form.Field>
    );

    const accountsEmail = (
      <Form.Field>
        <label>{polyglot.t("cafForm.accountsEmail")}</label>
      </Form.Field>
    );
    const purchasingEmail = (
      <Form.Field>
        <label>{polyglot.t("cafForm.purchasingEmail")}</label>
      </Form.Field>
    );

    return (
      <React.Fragment>
        <h3>{polyglot.t("cafForm.title.departmentContacts")}</h3>
        <Divider />

        <Grid columns="equal">
          <Grid.Column width={8} computer={8} mobile={16}>
            {manager}
          </Grid.Column>
          <Grid.Column width={8} computer={8} mobile={16}>
            {managersEmail}
          </Grid.Column>
          <Grid.Column width={8} computer={8} mobile={16}>
            {accounts}
          </Grid.Column>
          <Grid.Column width={8} computer={8} mobile={16}>
            {accountsEmail}
          </Grid.Column>
          <Grid.Column width={8} computer={8} mobile={16}>
            {purchasing}
          </Grid.Column>
          <Grid.Column width={8} computer={8} mobile={16}>
            {purchasingEmail}
          </Grid.Column>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    forms: state.forms,
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(cafReducer, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CafDepartmentForm);
